import {Component} from '@angular/core';
import {UserService} from "../../data/user/user.service";
import {SystemPermission} from "../../constants/permissions/system-permission";

@Component({
    selector: 'app-add-project-tile',
    templateUrl: './add-project-tile.component.html',
    styleUrls: ['./add-project-tile.component.scss'],
    standalone: false
})
export class AddProjectTileComponent {
  constructor() {
  }
}
